// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__aDkfN","bg":"Modal_bg__qicQQ","closeBtn":"Modal_closeBtn__Ux72A","content":"Modal_content__tp1V8"};